import { Navigate, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DashboardShell from '../../components/DashboardShell';
import { StudentSubjectSelectionProvider } from '../../hooks/useStudentSubjectSelectionStatus';
import { getUserDetails } from '../../redux/userRelated/userHandle';
import { getStudentClassId } from '../../utils/userContext';
import StudentSideBar from './StudentSideBar';
import StudentHomePage from './StudentHomePage';
import StudentProfile from './StudentProfile';
import AppSettingsPage from '../AppSettingsPage';
import StudentSubjects from './StudentSubjects';
import StudentResults from './StudentResults';
import StudentReportCard from '../admin/examRelated/StudentReportCard';
import StudentTranscript from '../admin/examRelated/StudentTranscript';
import ViewStdAttendance from './ViewStdAttendance';
import StudentComplain from './StudentComplain';
import StudentResources from './StudentResources';
import StudentFees from './StudentFees';
import StudentForm3SubjectChoice from './StudentForm3SubjectChoice';
import StudentSubjectSelectionGate from '../../components/student/StudentSubjectSelectionGate';

const StudentDashboard = () => {
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.user);
    const studentId = currentUser?._id || currentUser?.id;
    const classId = getStudentClassId(currentUser);

    useEffect(() => {
        if (!studentId) return;
        dispatch(getUserDetails(studentId, "Student"));
    }, [dispatch, studentId]);

    useEffect(() => {
        if (!studentId) return;
        const refreshProfile = () => dispatch(getUserDetails(studentId, "Student"));
        window.addEventListener("focus", refreshProfile);
        return () => window.removeEventListener("focus", refreshProfile);
    }, [dispatch, studentId]);

    return (
        <StudentSubjectSelectionProvider studentId={studentId} classId={classId}>
            <DashboardShell title="Student portal" sidebar={<StudentSideBar />} defaultDesktopOpen>
                <StudentSubjectSelectionGate>
                    <Routes>
                        <Route index element={<Navigate to="dashboard" replace />} />
                        <Route path="dashboard" element={<StudentHomePage />} />
                        <Route path="profile" element={<StudentProfile />} />
                        <Route path="app-settings" element={<AppSettingsPage />} />
                        <Route path="subjects" element={<StudentSubjects />} />
                        <Route path="form3-subjects" element={<StudentForm3SubjectChoice />} />
                        <Route path="resources" element={<StudentResources />} />
                        <Route path="results" element={<StudentResults />} />
                        <Route path="report-card" element={<StudentReportCard basePath="/Student" readOnly />} />
                        <Route path="transcript" element={<StudentTranscript basePath="/Student" readOnly />} />
                        <Route path="fees" element={<StudentFees />} />
                        <Route path="attendance" element={<ViewStdAttendance />} />
                        <Route path="complain" element={<StudentComplain />} />
                        <Route path="*" element={<Navigate to="dashboard" replace />} />
                    </Routes>
                </StudentSubjectSelectionGate>
            </DashboardShell>
        </StudentSubjectSelectionProvider>
    );
};

export default StudentDashboard;
